<template>
  <span>
    <b-button v-if="downloading" disabled variant="secondary" class="px-1 py-0 mr-1" :size="size">
      <i class="fa fa-spinner fa-spin"></i> Downloading
    </b-button>

    <b-button
      v-else
      variant="primary"
      class="px-1 py-0 mr-1"
      title="Download Export"
      :size="size"
      @click="download"
    >
      <i class="fa fa-download"></i> Download
    </b-button>
  </span>
</template>

<script>
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";
const ResultExportRepository = LabRepositoryFactory.get("resultExport");

export default {
  name: "ResultExportDownloadButton",
  props: {
    result_export: {
      type: Object,
      required: true,
    },
    size: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      downloading: false,
    };
  },
  methods: {
    /**
     * Trigger download of file
     */
    async download() {
      // set downloading flag
      this.downloading = true;

      //  request and download file
      await ResultExportRepository.download(this.result_export.id).then(
        (response) => {
          var fileURL = window.URL.createObjectURL(
            new Blob([Buffer.from(response.data.file, "base64")])
          );
          var fURL = document.createElement("a");

          fURL.href = fileURL;
          fURL.setAttribute("download", response.data.file_name);
          document.body.appendChild(fURL);

          fURL.click();
        }
      );

      // set downloading flag
      this.downloading = false;
    },
  },
};
</script>